import { useState } from 'react';
import type { HouseholdSharingPort } from '../application/household-sharing';
import { clearFederatedBootstrap } from '../infrastructure/federated-bootstrap';
import { useI18n } from '../i18n/I18nContext';

export const FederatedBootstrapFailure = ({ error, sharing, retry, navigate }: {
  readonly error: unknown;
  readonly sharing: HouseholdSharingPort;
  readonly retry: () => void;
  readonly navigate: (path: string) => void;
}) => {
  const { t } = useI18n();
  const [busy, setBusy] = useState(false);
  const [logoutFailed, setLogoutFailed] = useState(false);
  const awaitingKey = error instanceof Error && error.message === 'HOUSEHOLD_KEY_REQUIRED';
  const sessionRequired = error instanceof Error && error.message === 'HOUSEHOLD_SESSION_REQUIRED';
  const leave = async () => {
    setBusy(true);
    setLogoutFailed(false);
    try {
      if (!sessionRequired) await sharing.disconnect();
      clearFederatedBootstrap();
      navigate('/?connexion=1');
    } catch {
      setLogoutFailed(true);
      setBusy(false);
    }
  };
  return <main className="loading-screen" aria-busy={busy}>
    <p role="alert">{awaitingKey
      ? t('federatedFailure.awaitingKey')
      : t('federatedFailure.unavailable')}</p>
    <button type="button" disabled={busy} onClick={retry}>{t('federatedFailure.retry')}</button>
    <button type="button" disabled={busy} onClick={leave}>{sessionRequired
      ? t('federatedFailure.directLogin')
      : busy ? t('federatedFailure.disconnecting') : t('federatedFailure.leave')}</button>
    {logoutFailed ? <p role="alert">{t('federatedFailure.logoutFailed')}</p> : null}
  </main>;
};
